export default __webpack_public_path__ + "18e578601860b1de983f2078e00e4c61.jpeg";